export default "__VITE_PUBLIC_ASSET__e4deec0a__"